import {
  zoomIn,
  zoomInUp,
  zoomInDown,
  zoomInLeft,
  zoomInRight,
  zoomOut,
  zoomOutUp,
  zoomOutDown,
  zoomOutLeft,
  zoomOutRight,
} from 'ng-animate';

import { trigger, transition, useAnimation, AnimationTriggerMetadata } from '@angular/animations';

// ENTER

export const snZoomIn: AnimationTriggerMetadata = trigger('snZoomIn', [
  transition(':enter', useAnimation(zoomIn), {
    params: { timing: 0.3 },
  }),
]);

export const snZoomInDown: AnimationTriggerMetadata = trigger('snZoomInDown', [
  transition(':enter', useAnimation(zoomInDown), {
    params: { timing: 0.3 },
  }),
]);

export const snZoomInLeft: AnimationTriggerMetadata = trigger('snZoomInLeft', [
  transition(':enter', useAnimation(zoomInLeft), {
    params: { timing: 0.3 },
  }),
]);

export const snZoomInRight: AnimationTriggerMetadata = trigger('snZoomInRight', [
  transition(':enter', useAnimation(zoomInRight), {
    params: { timing: 0.3 },
  }),
]);

export const snZoomInUp: AnimationTriggerMetadata = trigger('snZoomInUp', [
  transition(':enter', useAnimation(zoomInUp), {
    params: { timing: 0.3 },
  }),
]);

// LEAVE
export const snZoomOut: AnimationTriggerMetadata = trigger('snZoomOut', [
  transition(':leave', useAnimation(zoomOut), {
    params: { timing: 0.3 },
  }),
]);

export const snZoomOutDown: AnimationTriggerMetadata = trigger('snZoomOutDown', [
  transition(':leave', useAnimation(zoomOutDown), {
    params: { timing: 0.3 },
  }),
]);

export const snZoomOutLeft: AnimationTriggerMetadata = trigger('snZoomOutLeft', [
  transition(':leave', useAnimation(zoomOutLeft), {
    params: { timing: 0.3 },
  }),
]);

export const snZoomOutRight: AnimationTriggerMetadata = trigger('snZoomOutRight', [
  transition(':leave', useAnimation(zoomOutRight), {
    params: { timing: 0.3 },
  }),
]);

export const snZoomOutUp: AnimationTriggerMetadata = trigger('snZoomOutUp', [
  transition(':leave', useAnimation(zoomOutUp), {
    params: { timing: 0.3 },
  }),
]);
